import * as React from 'react';

import { Grid } from "@material-ui/core";
import { MarketSharePublishers } from '../shared/market-share/MarketSharePublishers';
import { MarketShareRankingPublishers } from '../shared/ranking/MarketShareRankingPublishers';
import { MarketPublishersLastMonths } from '../shared/market-publishers-last-months/MarketPublishersLastMonths';


// tslint:disable-next-line:no-empty-interface
export interface IMarketPublisherBillingProps {
}

// tslint:disable-next-line:no-empty-interface
export interface IMarketPublisherBillingState {
}

export class MarketPublisherBilling extends React.Component<IMarketPublisherBillingProps, IMarketPublisherBillingState> {
    constructor(props: IMarketPublisherBillingProps) {
        super(props);
    }

    public render() {
        return (
            <Grid container={true} spacing={16}>
                <Grid item={true} xs={6} sm={6}>
                    <MarketSharePublishers  type='BILLING' />
                </Grid>
                <Grid item={true} xs={6} sm={6}>
                    <MarketShareRankingPublishers  type='BILLING' />
                </Grid>
                <Grid item={true} xs={12} sm={12}>
                    <MarketPublishersLastMonths type='BILLING' />
                </Grid>
            </Grid>
        );
    }
}



// WEBPACK FOOTER //
// ./src/component/market/general/publishers/billing/publisher.billing.tsx